import React, { useEffect, useState } from 'react'
import util from 'meinian-package/src/utils/util'
import Panel from './panel'
import MouseIcon from './component/mouseIcon'
import Nav from './component/nav'
import HighlightFont from './component/highlightFont'
import HighlightButton from './component/highlightButton'
import styles from './index.module.less'

export default () => {
  const [navValue, setNavValue] = useState(1)

  useEffect(() => {
    util.track('mn-novice-recommendation-page', {
    })
  }, [])

  return <div>
    <Nav
      options={[
        { label: '收藏图片', serialNumber: '01', value: 1 },
        { label: '管理素材', serialNumber: '02', value: 2 },
        { label: '素材导出', serialNumber: '03', value: 3 },
        { label: '邀请协作', serialNumber: '04', value: 4 },
        { label: '添加批注', serialNumber: '05', value: 5 },
        { label: '审核选款', serialNumber: '06', value: 6 },
        { label: '探索更多', serialNumber: '07', value: 7 },
      ]}
      value={navValue}
      style={{ top: 'calc(100vh / 2 - 225px)' }}
      onChange={(val) => {
        setNavValue(val)
        document.querySelector(`#noviceRecommendationPanel${val}`).scrollIntoView({ behavior: 'smooth', block: 'start' })
      }}
    />
    <div className={styles.noviceRecommendation}>
      <div className="noviceRecommendationTop">
        <div className="noviceRecommendationTopBg" style={{ backgroundImage: 'url(https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/background.png)' }} />
        <div className="noviceRecommendationTopFgWrap">
          <div className="noviceRecommendationTopFg" style={{ backgroundImage: 'url(https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/foreground.png)' }} />
        </div>
      </div>
      <div className="noviceRecommendationMainWrap">
        <div className="noviceRecommendationMain">
          <Panel
            titleDir="noviceRecommendationImage01"
            style={{ height: '1727px' }}
            title="panel01"
            id="noviceRecommendationPanel1"
            onChange={(val) => {
              if (val) {
                setNavValue(1)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <table className={styles.noviceRecommendationPanelContentTable}>
                <tbody>
                  <tr>
                    <td valign="top" className="column1">
                      <div className="column1Content">
                        <div className={styles.noviceRecommendationMainPotion} /><div className="column1Title">方式一</div>
                      </div>
                    </td>
                    <td valign="top" className="column2" style={{ width: '392px' }}>
                      <div className="column2Title">站内采集</div>
                      <div className="column2Content" style={{ marginTop: '8px' }}>浏览知衣系其他产品时(知衣/知款/抖衣…)，可随时<HighlightFont>采集图片至美念灵感集</HighlightFont>中收藏整理。</div>
                    </td>
                    <td valign="top" className="column3" style={{ width: '556px', textAlign: 'right', position: 'relative' }}>
                      <MouseIcon style={{ left: '65px', top: '16px' }} />
                      <MouseIcon style={{ right: '10px', top: '76px' }} />
                      <img style={{ width: '504px', height: '267px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/01-1-1.png" />
                    </td>
                  </tr>
                  <tr style={{ marginTop: '48px' }}>
                    <td valign="top" className="column1" />
                    <td valign="top" className="column2" style={{ width: '392px' }}>
                      <div className="column2Content" style={{ fontSize: '20px' }}>在「智能选款」中，系统将根据你的采集偏好，推荐更多优质灵感～</div>
                      <HighlightButton
                        style={{ marginTop: '12px' }}
                        onClick={() => {
                          util.track('mn-novice-recommendation-click', {
                            module1: '收藏图片-智能选款',
                          })
                          window.open('/meinian/home/intellectRecommend')
                        }}
                      >去看看</HighlightButton>
                    </td>
                    <td valign="top" className="column3" style={{ width: '556px', position: 'relative' }}>
                      <MouseIcon style={{ left: '71px', top: '157px' }} />
                      <img style={{ width: '504px', height: '212px', marginLeft: '50px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/01-1-2.png" />
                    </td>
                  </tr>
                  <tr style={{ marginTop: '48px' }}>
                    <td valign="top" className="column1" />
                    <td valign="top" className="column2" style={{ width: '392px' }}>
                      <div className="column2Content" style={{ fontSize: '20px' }}>采集的款式会带上原文信息，你可以在浏览图片时<HighlightFont>快速跳转原文</HighlightFont>查看更多。</div>
                    </td>
                    <td valign="top" className="column3" style={{ width: '556px', position: 'relative' }}>
                      <MouseIcon style={{ right: '67px', top: '120px' }} />
                      <img style={{ width: '480px', height: '232px', marginLeft: '50px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/01-1-3.png" />
                    </td>
                  </tr>
                  <tr style={{ marginTop: '80px' }}>
                    <td valign="top" className="column1">
                      <div className="column1Content">
                        <div className={styles.noviceRecommendationMainPotion} /><div className="column1Title">方式二</div>
                      </div>
                    </td>
                    <td valign="top" className="column2" style={{ width: '392px' }}>
                      <div className="column2Content">你还可以<HighlightFont>安装采集插件</HighlightFont>，在浏览其他服饰资讯网页时，也能原像素快速采集该网页的图片。</div>
                      <HighlightButton
                        style={{ marginTop: '12px' }}
                        onClick={() => {
                          util.track('mn-novice-recommendation-click', {
                            module1: '收藏图片-采集插件',
                          })
                          window.open('https://meinian.zhiyitech.cn/tool/index.html')
                        }}
                      >去看看</HighlightButton>
                    </td>
                    <td valign="top" className="column3" style={{ width: '556px', textAlign: 'right', position: 'relative' }}>
                      <MouseIcon style={{ top: '62px', left: '224px' }} />
                      <img style={{ width: '504px', height: '94px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/01-2-1.png" />
                    </td>
                  </tr>
                  <tr style={{ marginTop: '80px' }}>
                    <td valign="top" className="column1">
                      <div className="column1Content">
                        <div className={styles.noviceRecommendationMainPotion} /><div className="column1Title">方式三</div>
                      </div>
                    </td>
                    <td valign="top" className="column2" style={{ width: '392px' }}>
                      <div className="column2Content">不仅如此，美念也支持<HighlightFont>本地上传图片</HighlightFont><HighlightFont>(手机也能上传)</HighlightFont>，云端存储，移动端实时同步，让你随时随地想看就看！</div>
                      <HighlightButton
                        style={{ marginTop: '12px' }}
                        onClick={() => {
                          util.track('mn-novice-recommendation-click', {
                            module1: '收藏图片-上传',
                          })
                          window.open('/meinian/home/workbench/index')
                        }}
                      >去看看</HighlightButton>
                    </td>
                    <td valign="top" className="column3" style={{ width: '556px', textAlign: 'right', position: 'relative' }}>
                      <MouseIcon style={{ left: '245px', top: '90px' }} />
                      <MouseIcon style={{ left: '249px', top: '178px' }} />
                      <MouseIcon style={{ left: '466px', top: '82px' }} />
                      <img style={{ width: '504px', height: '244px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/01-3-1.png" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '收藏图片',
                  })
                  window.open('/meinian/home/workbench/index')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage01"
            style={{ height: '1080px', marginTop: '56px' }}
            title="panel02"
            id="noviceRecommendationPanel2"
            onChange={(val) => {
              if (val) {
                setNavValue(2)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel02}>
                <div className="column1">
                  <div className="column1Left">
                    <div className={styles.noviceRecommendationMainPotion} />
                    <div className="column1LeftText">
                      <HighlightFont>灵感集，可以理解为文件夹</HighlightFont>，用于存放收藏的图片。灵感集内还
                      <HighlightFont>可创建多层子灵感集</HighlightFont>，多层级灵感集帮助你更好地进行图片分类。
                    </div>
                  </div>
                  <div className="column1Right">
                    <img style={{ width: '112px', height: '112px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/02-4.png" />
                  </div>
                </div>
                <div className="column2">
                  <div className="column2Text">
                    <div className={styles.noviceRecommendationMainPotion} style={{ marginRight: '8px' }} />
                    创建的方式有3种：
                  </div>
                  <div className="column2Content">
                    <div className="column2ContentLeft">
                      <div>1. 点击页面右上角的「+」按钮并选择「新建灵感集」</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '231px', top: '243px' }} />
                        <img style={{ width: '344px', height: '280px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/02-1.png" />
                      </div>
                    </div>
                    <div className="column2ContentRight">
                      <div>2. 采集时在弹窗选择「新建灵感集」</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '206px', top: '277px' }} />
                        <img style={{ width: '374px', height: '280px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/02-2.png" />
                      </div>
                    </div>
                  </div>
                  <div className="column2Content" style={{ marginTop: '32px' }}>
                    <div className="column2ContentLeft">
                      <div>3. 在工作台，点击「新建灵感集」</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '390px', top: '99px' }} />
                        <img style={{ width: '640px', height: '128px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/02-3.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '素材管理',
                  })
                  window.open('/meinian/home/coll')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage01"
            style={{ height: '965px', marginTop: '56px' }}
            title="panel03"
            id="noviceRecommendationPanel3"
            onChange={(val) => {
              if (val) {
                setNavValue(3)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel03}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    <div>「下载」是下载图片，包括主图或非主图；「导出」是导出款式信息为表格，包括主图、链接、图源、价格等字段。</div>
                    <div style={{ marginTop: '16px' }}>当款式过多时，在美念下载/导出，可以节省您n倍的时间哦！</div>
                  </div>
                </div>
                <div className="column2">
                  <div className="column2Text">
                    <div className={styles.noviceRecommendationMainPotion} style={{ marginRight: '8px' }} />
                    创建的方式有3种：
                  </div>
                  <div className="column2Content">
                    <div className="column2Content1">
                      <div>1. 单个款式下载/导出</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '150px', top: '180px' }} />
                        <MouseIcon style={{ left: '150px', top: '240px' }} />
                        <img style={{ width: '241px', height: '360px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/03-1.png" />
                      </div>
                    </div>
                    <div className="column2Content2">
                      <div>2. 批量选择款式下载/导出</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '259px', top: '40px' }} />
                        <img style={{ width: '315px', height: '360px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/03-2.png" />
                      </div>
                    </div>
                    <div className="column2Content3">
                      <div>3. 选择灵感集下载/导出全部款式</div>
                      <div style={{ position: 'relative' }}>
                        <MouseIcon style={{ left: '145px', top: '306px' }} />
                        <img style={{ width: '231px', height: '361px', marginTop: '16px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation1/03-3.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '素材导出',
                  })
                  window.open('/meinian/home/coll')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage"
            style={{ height: '1056px', marginTop: '56px' }}
            title="panel04"
            id="noviceRecommendationPanel4"
            onChange={(val) => {
              if (val) {
                setNavValue(4)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel04}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    作为一款云协作选款平台，美念可以成为<HighlightFont>团队空间，整合各部门各成员的款式资源，</HighlightFont>
                    <HighlightFont>同步款式动态信息</HighlightFont>方便团队成员对接。只需要设置灵感集的<HighlightFont>「协作成员」</HighlightFont>，赋予不同
                    成员不同的协作权限。
                  </div>
                </div>
                <div className="column2">
                  比如：赋予团队leader“审核者”权限，可以审核、采集、编辑、删除款式；赋予同事“采集者”权限，可以往里采集添加图片；赋予其他部门成员“查看者”权限，只能查看灵感集款式。
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '159px', top: '158px' }} />
                  <MouseIcon style={{ left: '367px', top: '94px' }} />
                  <img style={{ width: '937px', height: '438px', marginTop: '32px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/1-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '邀请协作',
                  })
                  window.open('/meinian/home/coll')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage"
            style={{ height: '931px', marginTop: '56px' }}
            title="panel05"
            id="noviceRecommendationPanel5"
            onChange={(val) => {
              if (val) {
                setNavValue(5)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel05}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    在款式详情页，可对款式内所有图片进行<HighlightFont>框选「批注」</HighlightFont>，标注款式细节；
                    或在图片下方进行<HighlightFont>「评论」</HighlightFont>，记录选款灵感，沉淀讨论结果。
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '108px', top: '505px' }} />
                  <MouseIcon style={{ left: '740px', top: '48px' }} />
                  <img style={{ width: '820px', height: '499px', marginTop: '24px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/2-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '添加批注',
                  })
                  window.open('/meinian/home/style-trend')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage"
            style={{ height: '733px', marginTop: '56px' }}
            title="panel06"
            id="noviceRecommendationPanel6"
            onChange={(val) => {
              if (val) {
                setNavValue(6)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel06}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    <HighlightFont>
                      「审核」
                    </HighlightFont>是美念独有的选款标记功能，通过<HighlightFont>
                      新建灵感集时选择审核层级</HighlightFont>，标记灵感集内款式的<HighlightFont>通过状态</HighlightFont>，用来筛选款式或设计审稿，非常方便！
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '206px', top: '268px' }} />
                  <img style={{ width: '887px', height: '300px', marginTop: '24px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/3-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '审核选款',
                  })
                  window.open('/meinian/home/all')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage"
            style={{ height: '416px', marginTop: '56px' }}
            title="pannel07"
            id="noviceRecommendationPanel7"
            onChange={(val) => {
              if (val) {
                setNavValue(7)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationContentPanel07}>
                <div className={styles.noviceRecommendationMainPotion} />
                <div className="columnText">
                  当然，美念的功能远远不止于此，更多详细内容，可移步<HighlightFont>帮助中心</HighlightFont>
                  查看，或是联系我们为您的团队定制专属解决方案～
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-click', {
                    module1: '探索更多',
                  })
                  window.open('/meinian/document')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  </div>
}
